<template>
  <v-dialog
    class="rad-dialog"
    content-class="rad-dialog"
    v-model="show"
    fullscreen
  >
    <v-toolbar color="accent">
      <div
        class="d-flex flex-row align-center"
        style="cursor: pointer"
        @click="goHome"
      >
        <img src="@/assets/sum_rr1.svg" width="100px" max-height="46px" />
      </div>
    </v-toolbar>
    <iframe
      :src="'https://api.sum.ba/files/' + $route.query.fileId"
      style="width: 100%; height: 100%"
      frameborder="0"
    ></iframe>
  </v-dialog>
</template>
<script>
export default {
  // metaInfo: {
  //     title: 'Rad  - Registar radova'
  //   },
    data(){
        return{
            show: true
        }
    },
    methods:{
        goHome(){
            this.$router.replace('/')
        }
    }
}
</script>
<style lang="scss">
.rad-dialog {
  overflow-y: hidden !important;
}
</style>